// Where a public detail page's back control goes, and what it says (#4602).
//
// Founder, 2026-10-17: from the landing page's "Look up a college" section he
// opened University of Kansas, pressed the page's back control, and landed on
// the /colleges index (inside the app shell, signed in) instead of back where
// he was. The control always pointed at the index.
//
// The rule, for every detail page (college, news story, resource paper):
//  - arrived from another page on our site in this tab: step back in history,
//    labelled "Back", so the visitor returns to exactly where they were;
//  - arrived directly (Google, an ad, a Short, a shared link): there is no
//    page of ours behind them, and stepping back would leave the site, so the
//    control links the index and names it ("All colleges").
//
// The label always matches the destination. Never "Back" on a link that goes
// to the index, never the index's name on a control that steps back.

export const BACK_LABEL = 'Back';

// React Router's browser history stamps every entry it creates with `idx`,
// counting from 0 at the entry the visitor arrived on. idx > 0 means at least
// one page of ours sits behind this one in the tab. A `replace` keeps idx, so
// a page that rewrote its own URL on arrival (an ad landing tidying its query)
// still reads as a direct arrival. Anything unreadable is a direct arrival:
// the safe side is the index link, never a step out of the site.
export function hasInSiteHistory(historyState) {
    const idx = historyState && typeof historyState === 'object' ? historyState.idx : undefined;
    return Number.isInteger(idx) && idx > 0;
}

export function backControl({ inSiteHistory, fallbackTo, fallbackLabel }) {
    return inSiteHistory
        ? { goBack: true, to: fallbackTo, label: BACK_LABEL }
        : { goBack: false, to: fallbackTo, label: fallbackLabel };
}
